import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import MDTypography from "components/MDTypography";
import Swal from "sweetalert2";
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";

const DayToBeCopied = ({ AppDay1, AppDay2, GetAppDayById }) => {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const CopyDaySessionsFirst = async () => {
    const similarSessionsOnly =
      document.getElementById("SimilarOnlyCheck")?.checked || false;

    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "This will copy all therapists and sessions to the new day.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, start smart copy",
    });

    if (!confirmation.isConfirmed) return;

    Swal.fire({
      title: "Processing Smart Copy",
      html: "Please wait...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const bulkCopyReq = {
        fromDayId: AppDay1.id,
        toDayId: AppDay2.id,
        similarSessionsOnly: similarSessionsOnly,
      };

      const res = await AppointmentsApi.BulkSmartCopyDay(bulkCopyReq);

      if (res.status === "Success") {
        if (isMounted.current) {
          GetAppDayById(AppDay2.id);
        }
        await Swal.fire({
          title: "Done!",
          icon: "success",
          text: "Imported successfully.",
          timer: 2000,
        });
      } else {
        throw new Error(res.message || "Failed to copy schedule");
      }
    } catch (error) {
      Swal.fire({ title: "Error", icon: "error", text: error.message });
    }
  };

  return (
    <div>
      <div className="row mt-2">
        <div className="col-lg-12 d-flex align-items-center">
          <button onClick={CopyDaySessionsFirst} className="btn btn-dark mr-3">
            Start Smart Copy
          </button>
        </div>
      </div>
    </div>
  );
};

export default DayToBeCopied;
